import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import styles from './header.module.css'

const Header = ({ siteTitle }) => (
  <header className={styles.container}>
    <h1 className={styles.logo}>Van Dijck Jos BVBA <span>Loenhout</span></h1>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
